import React, { useState, useCallback, useRef } from 'react';
import { AgChartsReact } from 'ag-charts-react';

const AgCharts = ({chartRef, options}) => {
    return (
        <AgChartsReact 
        ref={chartRef} 
        options={options} />
    )
}

export default AgCharts;